import { render, staticRenderFns } from "./HermitageLogo.vue?vue&type=template&id=23adf961&"
import script from "./HermitageLogo.vue?vue&type=script&lang=js&"
export * from "./HermitageLogo.vue?vue&type=script&lang=js&"
import style0 from "./HermitageLogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports